export default "__VITE_ASSET__29erzbhPEsjZPpacW1i5Jg__";